import { Co2Section } from '@/domain/impact-co2/entities/question.entity';
import { translate } from '@/ui/i18n';
import { BuildingHeatingForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/BuildingHeatingForm';
import { EnergyForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/EnergyForm';
import { EquipmentForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/EquipmentForm';
import { GeneratorForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/GeneratorForm';
import { NonRecyclableWasteForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/NonRecyclableWasteForm';
import { OfficeSuppliesNewForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/OfficeSuppliesNewForm';
import { OfficeSuppliesRefurbishForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/OfficeSuppliesRefurbishForm';
import { RecyclableWasteForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/RecyclableWasteForm';
import { ScenographyNoRecyclableForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/ScenographyNoRecyclableForm';
import { ScenographyRecyclableForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/ScenographyRecyclableForm';
import { WaterForm } from '@/ui/pages/app/components/quiz-panel/co2/components/forms/WaterForm';
import { QuizFormSeparator } from '@/ui/pages/app/components/quiz-panel/co2/components/QuizFormSeparator';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { useExternalSubmitAnswer } from '@/ui/pages/external/hooks/useExternalSubmitAnswer';
import { GenericExternalPageVenue } from '@/ui/pages/external/venue/components/GenericExternalPageVenue';

export function Site() {
  return (
    <GenericExternalPageVenue>
      <Form />
    </GenericExternalPageVenue>
  );
}

export function Form({ readOnly = false }: { readOnly?: boolean }) {
  const { onDelete, onSubmit, onEdit } = useExternalSubmitAnswer();

  const sector = 'SITE';

  const panelOpen = !readOnly;
  return (
    <ImpactQuestionContext.Provider
      value={{ panelOpen: panelOpen, hideCompleted: false }}
    >
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.SCENOGRAPHY}`)}
      />
      <ScenographyNoRecyclableForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <ScenographyRecyclableForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.MATERIAL}`)}
      />
      <OfficeSuppliesNewForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <OfficeSuppliesRefurbishForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.BUILDING}`)}
      />
      <BuildingHeatingForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.ENERGY}`)}
      />
      <EnergyForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <GeneratorForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.WATER}`)}
      />
      <WaterForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.WASTE}`)}
      />
      <RecyclableWasteForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <NonRecyclableWasteForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
      <QuizFormSeparator
        label={translate(`Co2.Sections.${Co2Section.EQUIPMENT}`)}
      />
      <EquipmentForm
        sector={sector}
        onDelete={onDelete}
        onSubmit={onSubmit}
        onEdit={onEdit}
        isExternal
      />
    </ImpactQuestionContext.Provider>
  );
}
